import { SeatFormField, sortRooms } from '@exam-center/exam-event-management';
import { Grid, Text, Flex, ReadonlyField } from '@shared/components';

export interface LocationReadonlyFieldProps {
  slotProps?: {
    province?: {
      province: string;
      location: string;
    };
    room?: {
      roomData: {
        name: string;
        seat: number;
        floor: string;
        roomNumber: string | null;
        building: string;
      }[];
    };
    seat?: number;
    numberOfExaminees?: number;
  };
  isSeatEditable?: boolean;
}

export default function LocationReadonlyField(props: Readonly<LocationReadonlyFieldProps>) {
  const { slotProps, isSeatEditable = true } = props;
  const renderRoomInfo = (label: string, value: string | number) => (
    <Flex sx={{ alignItems: 'baseline', gap: (theme) => theme.spacing(1), flexShrink: 0 }}>
      <Text component='span' variant='body2Semibold'>
        {label}:{' '}
      </Text>
      <Text component='span' variant='body2'>
        {value}
      </Text>{' '}
    </Flex>
  );

  const roomData = slotProps?.room?.roomData ?? [];

  return (
    <Grid
      sx={{
        display: 'grid',
        gridTemplateColumns: '240px 1fr',
        gap: (theme) => theme.spacing(6),
        alignItems: 'start',
      }}
    >
      <Text variant='body1Semibold'>สถานที่สอบ</Text>

      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
        <Grid
          sx={{
            display: 'grid',
            gridTemplateColumns: '240px 1fr',
            gap: (theme) => theme.spacing(4),
          }}
        >
          <ReadonlyField label='จังหวัด' content={slotProps?.province?.province ?? ''} />
          <ReadonlyField label='สถานที่/หน่วยงาน' content={slotProps?.province?.location ?? ''} />
        </Grid>
        <ReadonlyField
          label='ห้องสอบ'
          content={
            <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(3) }}>
              {roomData.length > 0
                ? [...roomData].sort(sortRooms).map((item) => (
                    <Flex
                      sx={{
                        alignItems: 'baseline',
                        columnGap: (theme) => theme.spacing(3),
                        rowGap: (theme) => theme.spacing(1),
                        flexWrap: 'wrap',
                      }}
                      key={item.roomNumber}
                    >
                      {renderRoomInfo('อาคาร', item.building)}
                      {renderRoomInfo('ชั้น', item.floor)}
                      {renderRoomInfo('ห้อง', item.name)}
                      {renderRoomInfo('เลขห้อง', item.roomNumber ?? '-')}
                      {renderRoomInfo('จำนวนที่นั่ง', `${item.seat} ที่นั่ง`)}
                    </Flex>
                  ))
                : '-'}
            </Flex>
          }
        />
        <SeatFormField
          isSeatEditable={isSeatEditable}
          seat={slotProps?.seat ? slotProps.seat.toString() : ''}
          endContent={
            <Text variant='body2' sx={{ py: (theme) => theme.spacing(2.5) }}>
              (จำนวนที่ลงทะเบียน: {slotProps?.numberOfExaminees} ที่นั่ง)
            </Text>
          }
        />
      </Flex>
    </Grid>
  );
}
